import { Trophy } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { openChat } from "../../lib/api";
import { useContent, pick } from "../../lib/content";

const items = [
  ["Force et victoire", "Rituels pour donner la force, la rigueur et l'esprit de victoire à votre équipe favorite."],
  ["Protection des joueurs", "Protection contre les blessures, la malchance et les mauvais sorts pendant les matchs."],
  ["Chance et réussite", "Rituels de chance pour les matchs importants, les qualifications et les compétitions."],
];

export const Football = () => {
  const c = useContent();
  return (
  <section id="football" className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36" data-testid="football-section">
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal><Eyebrow>Travaux sur les matchs</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl leading-tight text-amber-50 sm:text-4xl lg:text-5xl">
            Matchs de Football
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-stone-300 md:text-lg whitespace-pre-line">
            {pick(c, "football_paragraph",
              "Donnez-moi le nom des deux équipes et la date du match dans la discussion instantanée, en toute discrétion. Le Maître Wouffa travaille ensuite pour votre camp. Le tarif dépend du travail et du match : il est fixé directement dans le chat, jamais d'avance.")}
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button onClick={() => openChat("Bonjour Maître, je veux un travail sur le match de football. Les deux équipes et la date du match sont : ")}
            data-testid="football-chat-button"
            className="mt-10 flex items-center gap-3 rounded-full bg-amber-400 px-7 py-3.5 text-sm font-bold uppercase tracking-[0.15em] text-stone-950 transition-transform duration-300 hover:scale-[1.03] active:scale-95">
            <Trophy className="h-4 w-4" /> Discuter de mon match
          </button>
        </Reveal>
      </div>
      <div className="flex flex-col gap-4 lg:col-span-6 lg:col-start-7">
        {items.map(([title, txt], i) => (
          <Reveal key={title} delay={0.1 * i}>
            <div className="flex items-start gap-5 rounded-2xl border border-amber-900/40 bg-[#181512] p-6 md:p-8" data-testid={`football-item-${i}`}>
              <span className="font-display text-3xl text-amber-500/60">0{i + 1}</span>
              <div>
                <p className="font-serif-it text-2xl italic text-amber-100">{title}</p>
                <p className="mt-2 text-sm leading-relaxed text-stone-300">{txt}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
